import React from 'react';
import Box from '../Box/Box';
import { Link } from '../Link';

type TAttribute = {
  title: string;
  linkTitle?: string;
  url: string;
  onClick?: () => void;
};

const DropdownTitleWithLink = ({ title, linkTitle, url, onClick, ...rest }: TAttribute) => (
  <Box
    {...rest}
    as="div"
    parent="Nav-dropdown-menu"
    name={title && !linkTitle ? 'titleWithoutLink' : 'titleWithLink'}
    onClick={onClick}
  >
    <Box as="div" name="title" parent={`Nav-dropdown-menu-${linkTitle ? 'titleWithLink' : 'titleWithoutLink'}`}>
      {title}
    </Box>

    {linkTitle && (
      <Box as="div" name="linkTitle" parent="Nav-dropdown-menu-titleWithLink">
        <Link href={url}>{linkTitle}</Link>
      </Box>
    )}
  </Box>
);

export default DropdownTitleWithLink;
